/******/ (() => {
  // webpackBootstrap
  /* eslint-disable */
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();

      /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
      this.onSwatchChangeBound = this.onSwatchChange.bind(this);
      this.onColorSwatchMouseEnterBound =
        this.onColorSwatchMouseEnter.bind(this);
      this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
    }

    connectedCallback() {
      this.colorLabel = this.querySelector("[data-color-swatch-name]");
      this.colorLabelState = this.querySelector("[data-color-swatch-state]");
      this.soldOutString = this.getAttribute("data-swatch-sold-out-string");
      this.colorSwatches = this.querySelectorAll(".swatch-element.color");
      this.sectionId = this.getAttribute("data-section-id");
      this.setEventListeners();
      this.setColorLabelState();
    }

    setEventListeners() {
      /* ===== Attach the event listeners to the DOM elements ===== */
      this.colorSwatches.forEach((swatch) => {
        swatch.addEventListener(
          "mouseenter",
          this.onColorSwatchMouseEnterBound
        );
        swatch.addEventListener("mouseleave", this.onSwatchMouseLeaveBound);
      });

      this.addEventListener("change", this.onSwatchChangeBound);
    }

    setColorLabelState() {
      /* ===== Set the color label state based on the active swatch ===== */
      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (!activeSwatch) return;

      const activeSwatchAvailable = activeSwatch.getAttribute(
        "data-swatch-option-available"
      );
      if (!this.soldOutString || !this.colorLabelState) return;

      // Set color label state (sold out or not)
      this.updateColorLabelState(activeSwatchAvailable);
    }

    updateColorLabelState(available) {
      /* ===== Set the color label state (sold out or not) ===== */
      if (this.colorLabelState) {
        this.colorLabelState.innerText =
          available === "false" ? `(${this.soldOutString})` : "";
      }
    }

    onSwatchChange(event) {
      const input = event.target;

      // Ajout : unicité de la classe active
      const allSwatches = input
        .closest(".swatch-items-wrapper")
        .querySelectorAll(".swatch-element");
      allSwatches.forEach((swatch) => swatch.classList.remove("active"));
      const swatchElement = input.closest(".swatch-element");
      if (swatchElement) swatchElement.classList.add("active");

      const currentVariant = this.getVariantData(input.id);
      const productUrl = input.getAttribute("data-product-url");
      const productFetchUrl = input.getAttribute("data-product-fetch-url");
      const isCombinedListing =
        input.getAttribute("data-is-combined-listing") === "true";
      const dataType = input.getAttribute("data-type");
      if (input.getAttribute("data-product-id")) {
        this.sectionId = input.getAttribute("data-product-id");
      }
      // get data-id attribute from the closest parent product-information element
      let containerId = input
        .closest("product-information")
        .getAttribute("data-original-section-id");

      // console.log("onSwatchChange", {
      //   sectionId: this.sectionId,
      //   variant: currentVariant,
      //   fetchURL: productFetchUrl,
      //   productURL: productUrl,
      //   isCombinedListing: isCombinedListing,
      //   containerId: containerId,
      //   type: dataType,
      // });

      this.emitVariantChangeEvent(
        currentVariant,
        productFetchUrl,
        productUrl,
        isCombinedListing,
        containerId,
        dataType
      );
    }

    emitVariantChangeEvent(
      variant,
      productFetchUrl,
      productUrl,
      isCombinedListing = false,
      containerId,
      type
    ) {
      /* ===== Emit the variant:change event ===== */
      eventBus.emit("variant:change", {
        sectionId: this.sectionId,
        variant: variant,
        fetchURL: productFetchUrl,
        productURL: productUrl,
        isCombinedListing: isCombinedListing,
        containerId: containerId,
        type: type,
      });
    }

    onColorSwatchMouseEnter(event) {
      /* ===== Update the color label on mouse enter ===== */
      this.updateColorLabel(event.currentTarget);

      // Add sibling hover active class
      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (activeSwatch && !event.currentTarget.classList.contains("active"))
        activeSwatch.classList.add("sibling-hover-active");
    }

    onSwatchMouseLeave() {
      /* ===== Reset the color label on mouse leave ===== */
      // Remove sibling hover active class
      const siblingHoverActiveSwatch = this.querySelector(
        ".swatch-element.sibling-hover-active"
      );
      if (siblingHoverActiveSwatch)
        siblingHoverActiveSwatch.classList.remove("sibling-hover-active");

      // Reset color label
      this.resetColorLabel();
    }

    updateColorLabel = (swatch) => {
      /* ===== Update the color label based on the swatch value ===== */
      if (!swatch) return;
      const label = swatch.getAttribute("data-value");
      const swatchAvailable = swatch.getAttribute(
        "data-swatch-option-available"
      );

      if (!label || !this.colorLabel) return;
      // Set color label text
      this.colorLabel.textContent = label;
      // Set color label state (sold out or not)
      this.updateColorLabelState(swatchAvailable);
    };

    resetColorLabel = () => {
      /* ===== Reset the color label to the active swatch value ===== */
      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (!activeSwatch || !this.colorLabel) return;

      const activeSwatchValue = activeSwatch.getAttribute("data-value");
      const swatchAvailable = activeSwatch.getAttribute(
        "data-swatch-option-available"
      );
      if (!activeSwatchValue) return;

      // Reset color label text
      this.colorLabel.textContent = activeSwatchValue;
      // Reset color label state (sold out or not)
      this.updateColorLabelState(swatchAvailable);
    };

    removeEventListeners() {
      /* ===== Remove the event listeners from the DOM elements ===== */
      this.colorSwatches.forEach((swatch) => {
        swatch.removeEventListener(
          "mouseenter",
          this.onColorSwatchMouseEnterBound
        );
        swatch.removeEventListener("mouseleave", this.onSwatchMouseLeaveBound);
      });

      this.removeEventListener("change", this.onSwatchChangeBound);
    }

    getVariantData(inputId) {
      return JSON.parse(this.getVariantDataElement(inputId).textContent);
    }

    getVariantDataElement(inputId) {
      return this.querySelector(
        `script[type="application/json"][data-resource="${inputId}"]`
      );
    }

    disconnectedCallback() {
      /* ===== Remove the event listeners when the element is removed from the DOM ===== */
      this.removeEventListeners();
    }
  }

  if (!window.customElements.get("product-swatch")) {
    window.customElements.define("product-swatch", ProductSwatch);
  }

  // Patch: Forcer un seul input radio checked par groupe de swatchs
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".swatch-items-wrapper").forEach((wrapper) => {
      const radiosByName = {};
      wrapper.querySelectorAll('input[type="radio"]').forEach((radio) => {
        if (!radiosByName[radio.name]) radiosByName[radio.name] = [];
        radiosByName[radio.name].push(radio);
      });
      Object.values(radiosByName).forEach((radios) => {
        let checkedFound = false;
        radios.forEach((radio) => {
          if (radio.checked) {
            if (!checkedFound) {
              checkedFound = true;
            } else {
              radio.checked = false;
            }
          }
        });
      });
    });
  });

  // Patch : Forcer l'unicité du checked à chaque interaction sur les swatchs
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".swatch-items-wrapper").forEach((wrapper) => {
      const radios = wrapper.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.addEventListener("change", function () {
          radios.forEach((r) => {
            if (r !== radio) r.checked = false;
          });
        });
      });
    });
  });

  /******/
})();
